<template>

    <!-- search-top -- >
    <div class="search-top">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <div class="search-box">
            <div class="todayselect">
              <select class="form-control" aria-label="agents">
                <option>Select agents</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-8">
          <div class="export-right">
            <div class="export">
              <a href="#"> My Reports</a>
            </div>
            <div class="todayselect">
              <div class="reportrange">
                This Month <i class="fa fa-angle-down" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <! -- search-top -->

    <!-- all-task -->
    <div class="all-task">
      <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Appointments.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ todayAppointments }}</h5>
                <p>Leads</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Tasks.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ newMessages }}</h5>
                <p>Today's Tasks</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Alarts.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ unreadMessages }}</h5>
                <p>Today’s Alerts</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Untouched.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ pendingFollowUp }}</h5>
                <p>Untouched Leads</p>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- all-task -->
    <!-- activity-area -->
    <div class="activity-area">
      <div class="row">
        <!-- left-side -->
        <div class="col-md-7 col-lg-8">
          <div class="row">
            <div class="col-12">
              <!-- activitybox -->
              <div class="activitybox">
                <div class="activetab">
                  <ul>
                    <li>
                      <a class="active" href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.3339 4.80612C12.8272 4.6869 14.2448 4.09954 15.3848 3.1277C16.6724 2.03102 18.3085 1.42871 19.9999 1.42871C21.6913 1.42871 23.3273 2.03102 24.615 3.1277C25.755 4.09954 27.1726 4.6869 28.6659 4.80612C30.3523 4.9409 31.9356 5.67195 33.1318 6.8682C34.3281 8.06446 35.0591 9.64771 35.1939 11.3341C35.3123 12.8268 35.8996 14.2452 36.8723 15.3851C37.969 16.6727 38.5713 18.3088 38.5713 20.0001C38.5713 21.6915 37.969 23.3276 36.8723 24.6152C35.9005 25.7553 35.3131 27.1729 35.1939 28.6662C35.0591 30.3526 34.3281 31.9358 33.1318 33.1321C31.9356 34.3283 30.3523 35.0594 28.6659 35.1942C27.1726 35.3134 25.755 35.9007 24.615 36.8726C23.3273 37.9693 21.6913 38.5716 19.9999 38.5716C18.3085 38.5716 16.6724 37.9693 15.3848 36.8726C14.2448 35.9007 12.8272 35.3134 11.3339 35.1942C9.64746 35.0594 8.06422 34.3283 6.86796 33.1321C5.6717 31.9358 4.94065 30.3526 4.80588 28.6662C4.68665 27.1729 4.0993 25.7553 3.12746 24.6152C2.03077 23.3276 1.42847 21.6915 1.42847 20.0001C1.42847 18.3088 2.03077 16.6727 3.12746 15.3851C4.0993 14.245 4.68665 12.8274 4.80588 11.3341C4.94065 9.64771 5.6717 8.06446 6.86796 6.8682C8.06422 5.67195 9.64746 4.9409 11.3339 4.80612V4.80612ZM28.6056 16.9985C29.0285 16.5606 29.2624 15.9742 29.2572 15.3656C29.2519 14.7569 29.0077 14.1746 28.5773 13.7442C28.1469 13.3138 27.5646 13.0696 26.9559 13.0643C26.3473 13.0591 25.7609 13.293 25.323 13.7159L17.6784 21.3605L14.6768 18.3589C14.2389 17.936 13.6525 17.702 13.0438 17.7073C12.4352 17.7126 11.8529 17.9567 11.4225 18.3871C10.9921 18.8176 10.7479 19.3998 10.7426 20.0085C10.7373 20.6172 10.9713 21.2036 11.3942 21.6414L16.0371 26.2844C16.4725 26.7196 17.0629 26.9641 17.6784 26.9641C18.294 26.9641 18.8844 26.7196 19.3197 26.2844L28.6056 16.9985V16.9985Z"
                            fill="#605BFF" />
                        </svg>
                        <h3>{{ newContacts }}</h3>
                        <p>Quotes Sent</p>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path
                            d="M30.0001 8.5715H28.5715V7.14293C28.5715 6.28578 28.0001 5.71436 27.1429 5.71436C26.2858 5.71436 25.7144 6.28578 25.7144 7.14293V8.5715H14.2858V7.14293C14.2858 6.28578 13.7144 5.71436 12.8572 5.71436C12.0001 5.71436 11.4286 6.28578 11.4286 7.14293V8.5715H10.0001C7.5715 8.5715 5.71436 10.4286 5.71436 12.8572V14.2858H34.2858V12.8572C34.2858 10.4286 32.4286 8.5715 30.0001 8.5715ZM5.71436 30.0001C5.71436 32.4286 7.5715 34.2858 10.0001 34.2858H30.0001C32.4286 34.2858 34.2858 32.4286 34.2858 30.0001V17.1429H5.71436V30.0001ZM27.1429 20.0001C28.0001 20.0001 28.5715 20.5715 28.5715 21.4286C28.5715 22.2858 28.0001 22.8572 27.1429 22.8572C26.2858 22.8572 25.7144 22.2858 25.7144 21.4286C25.7144 20.5715 26.2858 20.0001 27.1429 20.0001ZM27.1429 25.7144C28.0001 25.7144 28.5715 26.2858 28.5715 27.1429C28.5715 28.0001 28.0001 28.5715 27.1429 28.5715C26.2858 28.5715 25.7144 28.0001 25.7144 27.1429C25.7144 26.2858 26.2858 25.7144 27.1429 25.7144ZM20.0001 20.0001C20.8572 20.0001 21.4286 20.5715 21.4286 21.4286C21.4286 22.2858 20.8572 22.8572 20.0001 22.8572C19.1429 22.8572 18.5715 22.2858 18.5715 21.4286C18.5715 20.5715 19.1429 20.0001 20.0001 20.0001ZM20.0001 25.7144C20.8572 25.7144 21.4286 26.2858 21.4286 27.1429C21.4286 28.0001 20.8572 28.5715 20.0001 28.5715C19.1429 28.5715 18.5715 28.0001 18.5715 27.1429C18.5715 26.2858 19.1429 25.7144 20.0001 25.7144ZM12.8572 20.0001C13.7144 20.0001 14.2858 20.5715 14.2858 21.4286C14.2858 22.2858 13.7144 22.8572 12.8572 22.8572C12.0001 22.8572 11.4286 22.2858 11.4286 21.4286C11.4286 20.5715 12.0001 20.0001 12.8572 20.0001ZM12.8572 25.7144C13.7144 25.7144 14.2858 26.2858 14.2858 27.1429C14.2858 28.0001 13.7144 28.5715 12.8572 28.5715C12.0001 28.5715 11.4286 28.0001 11.4286 27.1429C11.4286 26.2858 12.0001 25.7144 12.8572 25.7144Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ appointmentScheduled }}</h3>
                        <p>Follow Up</p>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.332 8.85512C10.1223 8.78312 15.6896 6.61204 20 2.74512C24.3101 6.61276 29.8775 8.78457 35.668 8.85712C35.888 10.1571 36 11.4971 36 12.8591C36 23.3091 29.32 32.1991 20 35.4931C10.68 32.1971 4 23.3071 4 12.8571C4 11.4931 4.114 10.1571 4.332 8.85512ZM27.414 16.2711C27.7783 15.8939 27.9799 15.3887 27.9753 14.8643C27.9708 14.3399 27.7605 13.8383 27.3896 13.4675C27.0188 13.0967 26.5172 12.8863 25.9928 12.8818C25.4684 12.8772 24.9632 13.0788 24.586 13.4431L18 20.0291L15.414 17.4431C15.0368 17.0788 14.5316 16.8772 14.0072 16.8818C13.4828 16.8863 12.9812 17.0967 12.6104 17.4675C12.2395 17.8383 12.0292 18.3399 12.0247 18.8643C12.0201 19.3887 12.2217 19.8939 12.586 20.2711L16.586 24.2711C16.9611 24.6461 17.4697 24.8567 18 24.8567C18.5303 24.8567 19.0389 24.6461 19.414 24.2711L27.414 16.2711Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ noResponse }}</h3>
                        <p>Closed Won</p>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="activetab">
                  <ul>
                    <li>
                      <a class="active" href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.3339 4.80612C12.8272 4.6869 14.2448 4.09954 15.3848 3.1277C16.6724 2.03102 18.3085 1.42871 19.9999 1.42871C21.6913 1.42871 23.3273 2.03102 24.615 3.1277C25.755 4.09954 27.1726 4.6869 28.6659 4.80612C30.3523 4.9409 31.9356 5.67195 33.1318 6.8682C34.3281 8.06446 35.0591 9.64771 35.1939 11.3341C35.3123 12.8268 35.8996 14.2452 36.8723 15.3851C37.969 16.6727 38.5713 18.3088 38.5713 20.0001C38.5713 21.6915 37.969 23.3276 36.8723 24.6152C35.9005 25.7553 35.3131 27.1729 35.1939 28.6662C35.0591 30.3526 34.3281 31.9358 33.1318 33.1321C31.9356 34.3283 30.3523 35.0594 28.6659 35.1942C27.1726 35.3134 25.755 35.9007 24.615 36.8726C23.3273 37.9693 21.6913 38.5716 19.9999 38.5716C18.3085 38.5716 16.6724 37.9693 15.3848 36.8726C14.2448 35.9007 12.8272 35.3134 11.3339 35.1942C9.64746 35.0594 8.06422 34.3283 6.86796 33.1321C5.6717 31.9358 4.94065 30.3526 4.80588 28.6662C4.68665 27.1729 4.0993 25.7553 3.12746 24.6152C2.03077 23.3276 1.42847 21.6915 1.42847 20.0001C1.42847 18.3088 2.03077 16.6727 3.12746 15.3851C4.0993 14.245 4.68665 12.8274 4.80588 11.3341C4.94065 9.64771 5.6717 8.06446 6.86796 6.8682C8.06422 5.67195 9.64746 4.9409 11.3339 4.80612V4.80612ZM28.6056 16.9985C29.0285 16.5606 29.2624 15.9742 29.2572 15.3656C29.2519 14.7569 29.0077 14.1746 28.5773 13.7442C28.1469 13.3138 27.5646 13.0696 26.9559 13.0643C26.3473 13.0591 25.7609 13.293 25.323 13.7159L17.6784 21.3605L14.6768 18.3589C14.2389 17.936 13.6525 17.702 13.0438 17.7073C12.4352 17.7126 11.8529 17.9567 11.4225 18.3871C10.9921 18.8176 10.7479 19.3998 10.7426 20.0085C10.7373 20.6172 10.9713 21.2036 11.3942 21.6414L16.0371 26.2844C16.4725 26.7196 17.0629 26.9641 17.6784 26.9641C18.294 26.9641 18.8844 26.7196 19.3197 26.2844L28.6056 16.9985V16.9985Z"
                            fill="#605BFF" />
                        </svg>
                        <h3>{{ newContacts }}</h3>
                        <p>Qualified to Buy</p>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path
                            d="M30.0001 8.5715H28.5715V7.14293C28.5715 6.28578 28.0001 5.71436 27.1429 5.71436C26.2858 5.71436 25.7144 6.28578 25.7144 7.14293V8.5715H14.2858V7.14293C14.2858 6.28578 13.7144 5.71436 12.8572 5.71436C12.0001 5.71436 11.4286 6.28578 11.4286 7.14293V8.5715H10.0001C7.5715 8.5715 5.71436 10.4286 5.71436 12.8572V14.2858H34.2858V12.8572C34.2858 10.4286 32.4286 8.5715 30.0001 8.5715ZM5.71436 30.0001C5.71436 32.4286 7.5715 34.2858 10.0001 34.2858H30.0001C32.4286 34.2858 34.2858 32.4286 34.2858 30.0001V17.1429H5.71436V30.0001ZM27.1429 20.0001C28.0001 20.0001 28.5715 20.5715 28.5715 21.4286C28.5715 22.2858 28.0001 22.8572 27.1429 22.8572C26.2858 22.8572 25.7144 22.2858 25.7144 21.4286C25.7144 20.5715 26.2858 20.0001 27.1429 20.0001ZM27.1429 25.7144C28.0001 25.7144 28.5715 26.2858 28.5715 27.1429C28.5715 28.0001 28.0001 28.5715 27.1429 28.5715C26.2858 28.5715 25.7144 28.0001 25.7144 27.1429C25.7144 26.2858 26.2858 25.7144 27.1429 25.7144ZM20.0001 20.0001C20.8572 20.0001 21.4286 20.5715 21.4286 21.4286C21.4286 22.2858 20.8572 22.8572 20.0001 22.8572C19.1429 22.8572 18.5715 22.2858 18.5715 21.4286C18.5715 20.5715 19.1429 20.0001 20.0001 20.0001ZM20.0001 25.7144C20.8572 25.7144 21.4286 26.2858 21.4286 27.1429C21.4286 28.0001 20.8572 28.5715 20.0001 28.5715C19.1429 28.5715 18.5715 28.0001 18.5715 27.1429C18.5715 26.2858 19.1429 25.7144 20.0001 25.7144ZM12.8572 20.0001C13.7144 20.0001 14.2858 20.5715 14.2858 21.4286C14.2858 22.2858 13.7144 22.8572 12.8572 22.8572C12.0001 22.8572 11.4286 22.2858 11.4286 21.4286C11.4286 20.5715 12.0001 20.0001 12.8572 20.0001ZM12.8572 25.7144C13.7144 25.7144 14.2858 26.2858 14.2858 27.1429C14.2858 28.0001 13.7144 28.5715 12.8572 28.5715C12.0001 28.5715 11.4286 28.0001 11.4286 27.1429C11.4286 26.2858 12.0001 25.7144 12.8572 25.7144Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ appointmentScheduled }}</h3>
                        <p>Scheduled</p>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.332 8.85512C10.1223 8.78312 15.6896 6.61204 20 2.74512C24.3101 6.61276 29.8775 8.78457 35.668 8.85712C35.888 10.1571 36 11.4971 36 12.8591C36 23.3091 29.32 32.1991 20 35.4931C10.68 32.1971 4 23.3071 4 12.8571C4 11.4931 4.114 10.1571 4.332 8.85512ZM27.414 16.2711C27.7783 15.8939 27.9799 15.3887 27.9753 14.8643C27.9708 14.3399 27.7605 13.8383 27.3896 13.4675C27.0188 13.0967 26.5172 12.8863 25.9928 12.8818C25.4684 12.8772 24.9632 13.0788 24.586 13.4431L18 20.0291L15.414 17.4431C15.0368 17.0788 14.5316 16.8772 14.0072 16.8818C13.4828 16.8863 12.9812 17.0967 12.6104 17.4675C12.2395 17.8383 12.0292 18.3399 12.0247 18.8643C12.0201 19.3887 12.2217 19.8939 12.586 20.2711L16.586 24.2711C16.9611 24.6461 17.4697 24.8567 18 24.8567C18.5303 24.8567 19.0389 24.6461 19.414 24.2711L27.414 16.2711Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ noResponse }}</h3>
                        <p>Closed Lost</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- activitybox -->
            </div>
            <div class="col-12">
              <!-- activitybox -->
              <div class="activitybox">
                <div class="box-title">
                  <h3>Leads vs Serviced</h3>
                </div>
                <div class="chat-box">
                  <div id="Leads"></div>
<apexchart 
type="area" 
height="280" 
:options="leadsOptions" 
:series="leadsSeries"
></apexchart>
                </div>

              </div>
              <!-- activitybox -->
            </div>
          </div>
        </div>
        <!-- left-side -->
        <!-- right-side -->
        <div class="col-md-5 col-lg-4">
          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Project Statistics</h3>
            </div>
            <div class="chat-box">
              <div id="Serviced"></div>
<apexchart 
type="donut" 
height="220" 
:options="donutOptions" 
:series="donutSeries"
></apexchart>
            </div>

          </div>
          <!-- activitybox -->
          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Website Analytics</h3>
            </div>
            <div class="chat-box">
              <div id="Appointments"></div>
<apexchart 
type="bar" 
height="250" 
:options="appointmentOptions" 
:series="appointmentSeries"
></apexchart>
            </div>

          </div>
          <!-- activitybox -->
        </div>
        <!-- right-side -->
      </div>
    </div>
    <!-- activity-area -->
</template>
<script>
import $ from "jquery";
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  setup() {
    const Router = useRouter();
    if(localStorage.getItem("user_id") != 177){
      Router.push("/inbox/all");
    }

    // Open Modal
    const openModal = () => {
      $("#featureNotAvailable").modal("show");
    };

    // Close Modal
    const closeModal = () => {
      $("#featureNotAvailable").modal("hide");
    };
    // let barChartSeries = ref([]);
    let todayAppointments = ref(0);
    let newMessages = ref(0);
    let unreadMessages = ref(0);
    let pendingFollowUp = ref(0);
    let newContacts = ref(0);
    let activeContacts = ref(0);
    let coldContacts = ref(0);
    let appointmentScheduled = ref(0);
    let noResponse = ref(0);
    let messagesSent = ref(0);
    let repliesReceived = ref(0);
    let appointmentsSet = ref(0);
    let appsShown = ref(0);
    let optedOut = ref(0);

    let activeAppointments = ref(0);
    let inboundLeads = ref(0);
    let totalConversation = ref(0);
    let averageResponseTime = ref('0m');

/* CHARTS */
// ===========================================
    // 1. LEADS CHART CONFIG
    // ===========================================
    const leadsSeries = ref([
      { name: 'Leads', data: [51, 40, 18, 51, 41, 109, 100] },
      { name: 'Serviced', data: [35, 32, 42, 24, 34, 52, 43] }
    ]);
    
    const leadsOptions = ref({
      colors: ['#F7AE33', '#5B93FF'],
      chart: { type: 'area', toolbar: { show: false } }, // Toolbar false looks cleaner
      dataLabels: { enabled: false },
      stroke: { width: 2, curve: 'smooth' },
      xaxis: {
        // Safe fix: Added categories to prevent date parsing crash
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      },
      tooltip: {
         // simplified tooltip
      },
      legend: { position: 'top', horizontalAlign: 'right', offsetX: -10 }
    });

    // ===========================================
    // 2. ACTIVITIES CHART CONFIG
    // ===========================================
    const activitySeries = ref([
      { name: 'Out', data: [44, 55, 57] },
      { name: 'In', data: [76, 85, 101] }
    ]);

    const activityOptions = ref({
      colors: ['#5B93FF', '#83AAF5'],
      chart: { type: 'bar', toolbar: { show: false } },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 4, // 'endingShape' is deprecated, use borderRadius
        },
      },
      dataLabels: { enabled: false },
      stroke: { show: true, width: 2, colors: ['transparent'] },
      xaxis: {
        categories: ['Call', 'Email', 'Text'],
      },
      fill: { opacity: 1 },
      legend: { position: 'top', horizontalAlign: 'right', offsetX: -10 }
    });

    // ===========================================
    // 3. SOURCES CHART CONFIG
    // ===========================================
    const sourcesSeries = ref([
      { data: [21, 22, 10] }
    ]);

    const sourcesOptions = ref({
      chart: { type: 'bar', toolbar: { show: false } },
      colors: ['#5B93FF', '#14B2D4', '#F7AE33'],
      plotOptions: {
        bar: {
          columnWidth: '20%',
          distributed: true,
          borderRadius: 6,
        }
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      xaxis: {
        categories: ['Walk In', 'Phone', 'Internet']
      }
    });

    // ===========================================
    // 4. DONUT CHART CONFIG
    // ===========================================
    // Note: Donut series is a simple array, not an object array
    const donutSeries = ref([44, 55, 34]);

    const donutOptions = ref({
      chart: { type: 'donut' },
      colors: ['#5B93FF', '#14B2D4', '#FF8F6B'],
      dataLabels: { enabled: false },
      labels: ['New', ' Used', 'Purchase'],
      legend: { show: true, position: 'bottom', horizontalAlign: 'center' }
    });

    // ===========================================
    // 5. APPOINTMENTS CHART CONFIG
    // ===========================================
    const appointmentSeries = ref([
      { data: [32, 52, 58, 64, 12] }
    ]);

    const appointmentOptions = ref({
      chart: { type: 'bar', toolbar: { show: false } },
      colors: ['#14B2D4', '#5B93FF', '#19BE93', '#F7AE33', '#EA5757'],
      plotOptions: {
        bar: {
          barHeight: '20%',
          horizontal: true,
          distributed: true,
          borderRadius: 4,
          dataLabels: { position: 'top' }
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 0,
        offsetY: -20, // Adjusted to sit on top of thin bars
        style: { fontSize: '12px', colors: ['#000'] }
      },
      xaxis: {
        categories: ['Created', 'Scheduled', 'Confirmed', 'Show', 'No Show '],
      },
      legend: { show: false }
    });
/* CHARTS */
    const getDashboardData = async () => {
      const getFormData = new FormData();
      getFormData.append('dealer_id', localStorage.getItem('dealer_id'));
      getFormData.append('location_id', localStorage.getItem('location_id'));
      await axios
        .post(
          axios.defaults.baseUrl + "dashboard",
          getFormData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem('auth_token'),
            },
          }
        )
        .then((response) => {
          todayAppointments.value = response.data.data.todays_appointments;
          newMessages.value = response.data.data.new_messages;
          unreadMessages.value = response.data.data.unread_messages;
          pendingFollowUp.value = response.data.data.pending_follow_up;
          newContacts.value = response.data.data.new_contacts;
          activeContacts.value = response.data.data.active_contacts;
          coldContacts.value = response.data.data.cold_contacts;
          appointmentScheduled.value = response.data.data.appointment_scheduled;
          noResponse.value = response.data.data.no_response;
          messagesSent.value = response.data.data.messages_sent;
          repliesReceived.value = response.data.data.replies_received;
          appointmentsSet.value = response.data.data.appointments_set;
          appsShown.value = response.data.data.apps_shown;
          optedOut.value = response.data.data.opted_out;

          activeAppointments.value = response.data.data.active_appointments;
          inboundLeads.value = response.data.data.inbound_leads;
          totalConversation.value = response.data.data.total_conversations;
          averageResponseTime.value = response.data.data.average_response_time;
          // datatableInit();
        })
        .catch((error) => {
          window.showHideMainLoader(false);
          console.log(error);
          // showToast(error.response.data.status, error.response.data.message);
          return false;
        });
    }

    onMounted(() => {
      // console.log(localStorage.getItem('dealer_id'));
      // console.log(localStorage.getItem('location_id'));
      window.showHideMainLoader(false);
      getDashboardData();
      $(document).on('click','.menuwidth',function(e){
      console.log(e.target);
alert();
    });
    });

    return {
      openModal,
      closeModal,
      getDashboardData,
      todayAppointments,
      newMessages,
      unreadMessages,
      pendingFollowUp,
      newContacts,
      activeContacts,
      coldContacts,
      appointmentScheduled,
      noResponse,
      messagesSent,
      repliesReceived,
      appointmentsSet,
      appsShown,
      optedOut,
      activeAppointments,
      inboundLeads,
      totalConversation,
      averageResponseTime,

      // Return Leads
      leadsSeries,
      leadsOptions,
      // Return Activities
      activitySeries,
      activityOptions,
      // Return Sources
      sourcesSeries,
      sourcesOptions,
      // Return Donut
      donutSeries,
      donutOptions,
      // Return Appointments
      appointmentSeries,
      appointmentOptions
    };
  },
};
</script>
<style>
#printLead {
  display: none;
}

@media print {
  #printLead {
    display: block;
  }

  .main-area {
    display: none;
  }

  #leadDetailsContainer {
    display: block;
  }

  .mytable .table td:first-child {
    font-weight: 500;
  }

  .mytable .table td,
  .mytable .table th {
    padding: 8px 0;
    vertical-align: middle;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e6e7e8;
    font-size: 14px;
    line-height: 1.5;
    color: #63729a;
  }

  .mytable .table td,
  .mytable .table th {
    padding: 8px 0;
    vertical-align: middle;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e6e7e8;
    font-size: 14px;
    line-height: 1.5;
    color: #63729a;
  }

  span.dot {
    display: inline-block;
    height: 4px;
    width: 4px;
    background: #63729a;
    border-radius: 50%;
    margin-bottom: 1px;
    margin-right: 5px;
  }
}
</style>